import React, { Component } from 'react';
import { Translation } from 'react-i18next';
import { Button, Card, Col, Row, Space, Spin } from 'antd';
import { LoadingOutlined, PlusCircleOutlined } from '@ant-design/icons';
import {
  hasPermissionAdmin,
  pathRedirect,
} from '../../../elements/lib/hasPermissionAdmin';
import { getRouteFromPath } from '../../../Routes';

import JournalPartnerTagsAdminList from '../containers/JournalPartnerTagsAdminListContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import { pathTo } from '../../../Routes';
import Config from '../../../../../Config';
import QueryString from '../../../../../lib/QueryString';
import Logger from '../../../../../lib/Logger';
import { Redirect } from 'react-router-dom';
import { MixpanelTracker } from '../../../../../lib/Mixpanel';

class JournalPartnerTagsAdminScreen extends Component {
  static defaultProps = {
    limit: Config.get('DEFAULT_LIST_LENGTH', 10),
    isLoading: true,
  };

  state = {
    redirect: null,
  };

  trackerActions = (eventMixpanel, params = {}) => {
    if (this.props.role !== 1) {
      MixpanelTracker.mixpanelTrack(eventMixpanel, {
        partnershipName: this.props.partnershipName ?? 'No partnership',
        partnershipId: this.props.partnershipId ?? 'No partnership',
        ...params,
      });
    }
  };

  scrollToTop = () => {
    Logger.log('debug', `JournalPartnerTagsAdminScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  render() {
    const loadingIcon = (
      <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />
    );
    const page = parseInt(
      this.props.match.params.page ? this.props.match.params.page : 1
    );
    const { order, ...filter } = QueryString.parse(this.props.location.search);

    const { redirect } = this.state;

    if (redirect) {
      return <Redirect to={pathTo(redirect)} />;
    }

    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('journal_partner_tags_route_list')} />

            <Row>
              <Col span={24}>
                <Card
                  title={
                    <Space size={10}>
                      {t('journal_partner_tags_list_title')}
                      <Button
                        size='small'
                        icon={<PlusCircleOutlined />}
                        onClick={(e) =>
                          this.props.history.push(
                            pathTo('JournalPartnerTagAdminAddScreen', {
                              id_partnership: this.props.partnershipId,
                            })
                          )
                        }
                      >
                        {t('action_create')}
                      </Button>
                    </Space>
                  }
                  extra={this.props.isLoading ? loadingIcon : null}
                >
                  <JournalPartnerTagsAdminList
                    key={page}
                    component='JournalPartnerTagsAdminScreen'
                    page={page}
                    limit={this.props.limit}
                    order={order || 'updated_at.desc'}
                    filter={filter}
                    trackerActions={this.trackerActions}
                  />
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }

  componentDidUpdate(prevProps) {
    Logger.log('silly', `PartnershipAccountScreen.componentDidUpdate()`);
    const route = getRouteFromPath(this.props.location.pathname);
    const screen = hasPermissionAdmin();
    if (
      this.props.partnershipId !== prevProps.partnershipId &&
      route.screen !== pathRedirect(screen)[0]
    ) {
      this.setState({ redirect: pathRedirect(screen)[0] });
    }
  }
}

export default JournalPartnerTagsAdminScreen;

Logger.log('silly', `JournalPartnerTagsAdminScreen loaded.`);
